import SortableMin from 'sortablejs';
import ViewBase from '../../view-base.view';

export default function UDFSortableListView() {
    ViewBase.call(this);

    let sortable;

    let onRemove = (e) => { };
    let removeItem = (seq) => {
        onRemove(seq);
    }

    return {
        oninit: function (vnode) {
            if (vnode.attrs.onRemove) {
                onRemove = vnode.attrs.onRemove;
            }
            if (vnode.attrs.userID) {
                userID = vnode.attrs.userID;
            }
        },
        onupdate: function (vnode) {
            var itemsList = document.getElementById("items-list");
            sortable = new SortableMin(itemsList, {
                animation: 150,
                ghostClass: 'sortable-ghost',
                dragClass: 'sortable-drag',
                handle: '.drag-grip',
            });
        },
        view: (vnode) => {
            return [
                m('ul[id="items-list"].moveable.p-0',
                    vnode.attrs.valueList.map(dtVal => [
                        m('li.drag-grip', { 'data-id': dtVal.sequence },
                            m('.row',
                                m('.col-sm-8',
                                    m('input[type="hidden"]'),
                                    m("input[type='text']", {
                                        "class": "form-control form-control-bg",
                                        value: dtVal.value,
                                        onkeyup: e => {
                                            dtVal.value = e.target.value;
                                        }
                                    })
                                ),
                                m('.col-md-2.mt-1',
                                    dtVal.inUse == "Y" &&
                                    m('label.switcher', m('input[type="checkbox"][checked]',
                                        {
                                            onchange: e => {
                                                dtVal.inUse = e.target.checked ? 'Y' : 'N';
                                            }
                                        }
                                    ), m('span[data-checked=' + this.getText("LT00000023", "Yes") + '][data-unchecked=' + this.getText("LT00000024", "No") + '].slider .round')),
                                    dtVal.inUse == "N" &&
                                    m('label.switcher', m('input[type="checkbox"]',
                                        {
                                            onchange: e => {
                                                dtVal.inUse = e.target.checked ? 'Y' : 'N';
                                            }
                                        }), m('span[data-checked=' + this.getText("LT00000023", "Yes") + '][data-unchecked=' + this.getText("LT00000024", "No") + '].slider .round'))

                                ),
                                !dtVal.udfValueId && m('.col-md-1', m('.remove_field.mt-1',
                                    {
                                        onclick: e => {
                                            removeItem(dtVal.sequence, vnode.attrs.valueList);
                                        }
                                    },
                                    m('span', m('i.bi.bi-dash-circle.me-0'))))
                            ),

                        )
                    ]),

                ), this.getBaseViews()];
        }
    }
}
